export const APP_ROUTES = {
  home: "/",
  dashboard: "/dashboard",
  signIn: "/sign-in",
  members: "/members",
  templates: "/templates",
  branding: "/branding",
  signUp: "/sign-up",
};
